'use strict';

export default function jQueryExtensions () {
    let jQueryFn = $.fn;

    jQueryFn.getPropAvg = function (propName) {
        let total = 0;

        if (typeof propName === 'undefined') {
            return total;
        }

        this.each((idx, el) => {
            let propVal = $(el).attr(propName);

            if (typeof propVal !== 'undefined') {
                total += parseFloat(propVal);
            }
        });

        return total/this.length;
    };
}
